<div class="mainContainer">
    <app-header></app-header>
    <div class="centerContainer">
        <router-outlet></router-outlet>
    </div>
    <footer>
        <app-footer></app-footer>
    </footer>
</div>